import ReactDOM from 'react-dom';
import { useCallback, useRef, useState } from 'react';
import Modal from 'src/Utils/CssModules/modal.module.css';
import useOutsideClick from 'src/Utils/Hooks/UseOutSideClick/UseOutSideClick';
import './PopupDialog.css';
import closeIcon from "src/images/close-icon.svg";

export interface IPopupDialogParams {
    children: React.ReactNode;
    onClose: () => void;
    marginTop?: string;
    popupWidth?: string;
    isOutsideClickAllowed?: boolean;
}

const PopupDialog: React.FC<IPopupDialogParams> = ({ children, onClose, marginTop, popupWidth, isOutsideClickAllowed=true }) => {
    const marginFromTop = marginTop || '200px';
    const [display, setDisplay] = useState('block');
    const wrapperRef = useRef<HTMLDivElement>(null);

    const close = useCallback(() => {
        setDisplay('none');
        onClose();
    }, [onClose]);

    // Always call the hook, but conditionally handle the outside click
    useOutsideClick(wrapperRef, () => {
        if (isOutsideClickAllowed) {
            close();
        }
    });
    
    // Render the modal content using React Portal
    return ReactDOM.createPortal(
        <div className="row">
            <div
                id="myModal"
                className={`${Modal.modal}`}
                style={{ display: display, zIndex: 1003, paddingTop: marginFromTop }}
            >
                <div
                    className={`${Modal.content} content`}
                    ref={wrapperRef}
                    style={{ width: popupWidth }}
                >
                    <div className="row">
                        <i
                            className="ds-text-primary ds-cursor-pointer"
                            onClick={() => onClose()}
                        >
                            <img src={closeIcon} className="close-icon" alt="close" />
                        </i>
                    </div>
                    {children}
                </div>
            </div>
        </div>,
        document.body // Render the modal at the root level of the DOM
    );
};

export default PopupDialog;